import React, { useEffect, useState } from "react";
import { Link, Switch, Route } from "react-router-dom";

import AllSymbol from "../symbol/price";

import styled from "styled-components";
import {
  styleHeaderDashboard,
  styleBitAsk,
  styleSpreadDashboard,
  styleBuyDashboard,
  styleSellDashboard,
} from "../symbol/style";
import { collection, onSnapshot } from "firebase/firestore";
import {
  cfds,
  cfdsData,
  commoditiesData,
  cryptoData,
  indexData,
  stockData,
  thematic,
  thematicData,
} from "../symbol/dataSymbol";
import { db } from "../../firebase";
import { useSelector } from "react-redux";
const locale = require("react-redux-i18n").I18n;

const TopMenu = styled.div`
  background: rgb(255, 255, 255);
  margin-top: 0px;
  border-radius: 20px;
`;
const MenuItem = styled.div`
  color: ${(props) => props.color};
  white-space: pre;
  padding: 0.8rem 1rem;
  font-weight: ${(props) => props.fontWeight};
  &:after {
    display: block;
    content: "";
    margin-top: 0.8rem;
    border-bottom: 4px solid #1cb894;
    transform: scaleX(${(props) => (props.borderBottom ? 1 : 0)});
    transition: transform 250ms ease-in-out;
  }
  &:hover:after {
    transform: scaleX(1);
  }
`;
const SearchResault = styled.div`
  position: absolute;
  background: #fff;
  width: 138px;
  z-index: 2;
  max-height: 50vh;
  overflow: auto;
`;

const SearchInput = styled.input`
  outline: none;
  background: #151e20;
  border: 1px solid #454a4c;
  border-radius: 4px;
  padding: 0 12px;
  color: #fff;
  height: 40px;
`;

const Symbols = (props) => {
  const pathName = window.location.pathname;
  const { profile } = useSelector((state) => state?.user);
  const [isIdex, setIndex] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [resault, setResault] = useState([]);

  const currency = [
    "AUDUSD",
    "CADJPY",
    "EURGBP",
    "EURJPY",
    "EURUSD",
    "GBPUSD",
    "NZDUSD",
    "USDCAD",
    "USDCHF",
    "USDJPY",
    "AUDCAD",
    "AUDCHF",
    "AUDJPY",
    "AUDNZD",
    "CADCHF",
    "CHFJPY",
    "CHFSGD",
    "ERUAUD",
    "EURCAD",
    "EURCHF",
    "EURDKK",
    "EURHKD",
    "EURHUF",
    "EURMXN",
    "EURNOK",
    "EURNZD",
    "EURPLN",
    "EURSEK",
    "EURTRY",
    "ERUZAR",
    "GBPAUD",
    "GBPCAD",
    "GBPCHF",
    "GBPDKK",
    "GBPJPY",
    "GBPNOK",
    "GBPNZD",
    "GBPSEK",
    "GBPTRY",
    "NZDCAD",
    "NZDCHF",
    "NZDJPY",
    "NZDSGD",
    "USDCNH",
    "USDZCK",
    "USDDKK",
    "USDHKD",
    "USDHUF",
    "USDMXN",
    "USDNOK",
    "USDPLN",
    "USDRUB",
    "USDSEK",
    "USDSGD",
    "USDTRY",
    "USDZAR",
    "UKOUSD",
    "USOUSD",
    "XAGEUR",
    "XAGUSD",
    "XAUEUR",
    "XAUUSD",
    "XNGUSD",
    "XPDUSD",
    "XPTUSD",
    "EURAUD",
    "USDCNY",
    "EURSGD",
    "USDTHB",
    "GBPSGD",
    "CADSGD",
    "AUDSGD",
    "SGDJPY",
    "XAUGBP",
  ];

  const cryptoCurrency = [
    "BTCEUR",
    "BTCGBP",
    "BTCUSD",
    "DSHUSD",
    "ETHEUR",
    "ETHGBP",
    "ETHUSD",
    "LTCUSD",
    "XRPUSD",
    "DOTUSD",
    "BCHUSD",
    "BNBUSD",
    "XMRUSD",
    "ADAUSD",
    "ADAUSD",
    "UNIUSD",
    "XTZUSD",
    "DOTUSD",
    "SOLUSD",
    "BATUSD",
    "TRXUSD",
    "XMRUSD",
    "ATMUSD",
    "AVAUSD",
  ];

  const indexs = [
    "100GBP",
    "AUS200",
    "D30EUR",
    "DJI30",
    "DXYUSD",
    "E35EUR",
    "E50EUR",
    "F40EUR",
    "JPN225",
    "NASUSD",
    "SP500",
    "USOIL",
    "HK50",
    "DE30",
    "US30",
    "S&P500",
    "UK100",
    "DXY",
    "FR40",
    "STOXX50",
    "USTEC",
  ];

  const marketStock = [
    "AAPL",
    "ADBE",
    "ALIBABA",
    "AMZN",
    "AMD",
    "BA",
    "BABA",
    "BAC",
    "CHTR",
    "CMCSA",
    "CME",
    "COST",
    "CSCO",
    "CSX",
    "CVS",
    "Citi",
    "EA",
    "EBAY",
    "EQIX",
    "Ford",
    "GILD",
    "GOOGL",
    "HD",
    "IBM",
    "INTC",
    "ISRG",
    "JNJ",
    "JPM",
    "KO",
    "LIN",
    "LLY",
    "LMT",
    "MA",
    "MCD",
    "MDLZ",
    "MMM",
    "MRK",
    "MS",
    "MSFT",
    "NFLX",
    "NKE",
    "NVDA",
    "ORCL",
    "PEP",
    "PFE",
    "PG",
    "PYPL",
    "SBUX",
    "TMO",
    "TMUS",
    "TSLA",
    "UNH",
    "VRTX",
    "Visa",
    "WMT",
    "XOM",
    "META",
  ];

  const load = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const onSearch = (event) => {
    if (event.target.value !== "") {
      var updatedList = filteredData;
      updatedList = updatedList.filter((item) => {
        return (
          item.toLowerCase().search(event.target.value.toLowerCase()) !== -1
        );
      });
      setResault(updatedList);
    } else {
      setResault([]);
    }
  };

  // useEffect(() => {
  //   const pusher = new Pusher("44f2900f2b03ee38357a", {
  //     cluster: "ap1",
  //     appId: 1158859,
  //     encrypted: true,
  //   });
  //   const channel = pusher.subscribe("quotes");

  //   channel.bind("update", function (e) {
  //     if (e.length > 10) {
  //       const isFilter = [];
  //       const filteredMarketStock2 = e.forEach((data) => {
  //         const matchingStock = marketALL.find(
  //           (stock) => stock.name.toLowerCase() === data.s.toLowerCase()
  //         );

  //         if (matchingStock) {
  //           data.display = matchingStock.display;
  //         }
  //       });

  //       const a = e.filter((ab) => currency.includes(ab.s));
  //       const b = e.filter((bc) => cryptoCurrency.includes(bc.s));
  //       const c = e.filter((cd) => indexs.includes(cd.s));
  //       const d = e.filter((de) => marketStock.includes(de.s));
  //       const f = e.filter((fg) => searchResault.includes(fg.s));

  //       setData(e);
  //       setCurrencies(a);
  //       setCrrypto(b);
  //       setMarketIndex(c);
  //       setStocks(d);
  //       setSearch(f);
  //       isFilter.push(e.map((s) => s.s));
  //       setFilteredData(isFilter[0]);
  //     }
  //   });
  //   const activeCover = () => {
  //     if (pathName) {
  //       menu.filter((e, i) => e.link === pathName && setIndex(e.id));
  //     }
  //   };
  //   activeCover();
  // }, [pathName]);
  const [priceData, setPriceData] = useState(null);
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    const collectionRef = collection(db, "Markets");
    const unsubscribe = onSnapshot(collectionRef, (querySnapshot) => {
      const markets = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
      }));

      let symbolsToInclude = [
        ...cfdsData,
        // ...cryptoData,
        ...commoditiesData,
        ...stockData,
        ...indexData,
        ...thematicData,
      ];

      if (
        profile?.country_id !== 1 &&
        localStorage.getItem("country") !== "TH"
      ) {
        symbolsToInclude = [...symbolsToInclude, ...cryptoData];
      } else {
        const cryptoCurrencyExclude = [
          "BTCUSD",
          "ETHUSD",
          "LTCUSD",
          "DOTUSD",
          "BCHUSD",
          "BNBUSD",
          "XMRUSD",
          "ADAUSD",
          "UNIUSD",
          "XTZUSD",
          "SOLUSD",
          "BATUSD",
          "TRXUSD",
          "ATMUSD",
          "AVAUSD",
        ];

        symbolsToInclude = [
          ...symbolsToInclude,
          ...cryptoData.filter(
            (symbol) => !cryptoCurrencyExclude.includes(symbol.name)
          ),
        ];
      }

      const filteredDataArray = symbolsToInclude
        ?.filter((symbol) => markets?.[0]?.[symbol.name]) // Ensure the symbol exists in the data
        .map((symbol) => ({
          ...markets?.[0]?.[symbol.name],
          Symbol: symbol.name,
          Display: symbol.display,
          disable: symbol.disable ?? false,
        }));

      setPriceData(filteredDataArray);
      // setPriceData(filteredDataArray);
    });

    // Clean up the listener on unmount
    return () => unsubscribe();
  }, [profile]);
  const lang = localStorage.getItem("locale");

  useEffect(() => {
    if (profile?.country_id !== 1 && localStorage.getItem("country") !== "TH") {
      setMenu([
        {
          id: 0,
          link: `/${localStorage.getItem("locale")}/wallet/spread`,
          text: locale.t("All"),
        },
        {
          id: 1,
          link: `/${localStorage.getItem("locale")}/wallet/spread/currency`,
          text: locale.t("Currency"),
        },
        {
          id: 2,
          link: `/${localStorage.getItem("locale")}/wallet/spread/crypto`,
          text: locale.t("Crypto"),
        },
        {
          id: 3,
          link: `/${localStorage.getItem("locale")}/wallet/spread/index`,
          text: locale.t("INDEX"),
        },
        {
          id: 4,
          link: `/${localStorage.getItem("locale")}/wallet/spread/stocks`,
          text: locale.t("STOCKS"),
        },
        {
          id: 5,
          link: `/${localStorage.getItem("locale")}/wallet/spread/thematic`,
          text: locale.t("dashboardSpread.thematic"),
        },
      ]);
    } else {
      setMenu([
        {
          id: 0,
          link: `/${localStorage.getItem("locale")}/wallet/spread`,
          text: locale.t("All"),
        },
        {
          id: 1,
          link: `/${localStorage.getItem("locale")}/wallet/spread/currency`,
          text: locale.t("Currency"),
        },
        {
          id: 3,
          link: `/${localStorage.getItem("locale")}/wallet/spread/index`,
          text: locale.t("INDEX"),
        },
        {
          id: 4,
          link: `/${localStorage.getItem("locale")}/wallet/spread/stocks`,
          text: locale.t("STOCKS"),
        },
        {
          id: 5,
          link: `/${localStorage.getItem("locale")}/wallet/spread/thematic`,
          text: locale.t("dashboardSpread.thematic"),
        },
      ]);
    }
  }, [profile]);

  return (
    <div>
      <div
        className=" w-100 pl-0 pr-0"
        // style={{ paddingTop: window.innerWidth <= 425 ? "20%" : "5%" }}
      >
        <TopMenu>
          {" "}
          <div className="d-flex justify-content-between w-100 p-4 align-items-center">
            <h6 className=" font-bold-iux text-left fs-32 text-uppercase">
              {locale.t("market")}
            </h6>
          </div>
          <div className="sub-menu-page-user" key={2}>
            <div className="container">
              <div className="d-flex overflow-auto scroll-menu-hide">
                {menu.map((e, i) => (
                  <Link to={e.link}>
                    <MenuItem
                      onClick={() => setIndex(i)}
                      color={e.link === pathName ? "#000" : "#8D8D8D"}
                      borderBottom={e.link === pathName}
                      fontWeight={e.link === pathName ? 700 : "unset"}
                    >
                      {e.text}
                    </MenuItem>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </TopMenu>
      </div>
      <div className="container mt-4">
        <div className="row">
          {priceData === null ? (
            load.map((e) => (
              <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                <div
                  className={`w-100 ${"bg-spreads-box-dashboard"} border-round-16 mb-2 p-0`}
                >
                  <div className="p-3 p-lg-2 p-md-2 box-market-landingpage">
                    <div
                      className="d-flex justify-content-between"
                      style={styleHeaderDashboard}
                    >
                      <div>Loading ...</div>
                    </div>

                    <div
                      className="d-flex justify-content-between pl-3 pr-3"
                      // style={styleBackground}
                    >
                      <div className="w-100">
                        <div style={styleBitAsk}>Bid</div>
                        0.0
                      </div>

                      <div className="w-100">
                        <div style={styleBitAsk} className="ml-2">
                          Ask
                        </div>
                        0.0
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-between"
                      // style={styleBottom}
                    >
                      <div className="w-100">
                        <div
                          className=" d-flex justify-content-between mr-1 btn-outline-iux"
                          style={styleSpreadDashboard}
                        >
                          Spread 0.0
                        </div>
                      </div>
                      <div className="w-100">
                        <div className="d-flex justify-content-between ml-1 ">
                          <>
                            <div className="" />
                            <Link
                              to={`/${localStorage.getItem("locale")}/login`}
                            >
                              <button
                                style={styleBuyDashboard}
                                className="btn-primary-new-iux"
                              >
                                Buy
                              </button>
                            </Link>
                            <Link
                              to={`/${localStorage.getItem("locale")}/login`}
                            >
                              <div
                                className="btn-outline-iux"
                                style={styleSellDashboard}
                              >
                                Sell
                              </div>
                            </Link>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Switch>
              <Route
                path={`/:lang/wallet/spread/stocks`}
                render={() => {
                  return (
                    <AllSymbol
                      data={priceData?.filter((ab) =>
                        marketStock.includes(ab.Symbol)
                      )}
                      islayout="dashboard"
                    />
                  );
                }}
              />
              <Route
                path={`/:lang/wallet/spread/thematic`}
                render={() => {
                  return (
                    <AllSymbol
                      data={priceData?.filter((ab) =>
                        thematic.includes(ab.Symbol)
                      )}
                      islayout="dashboard"
                    />
                  );
                }}
              />
              <Route
                path={`/:lang/wallet/spread/index`}
                render={() => {
                  return (
                    <AllSymbol
                      data={priceData?.filter((ab) =>
                        indexs.includes(ab.Symbol)
                      )}
                      islayout="dashboard"
                    />
                  );
                }}
              />
              <Route
                path={`/:lang/wallet/spread/crypto`}
                render={() => {
                  return (
                    <AllSymbol
                      data={priceData?.filter((ab) =>
                        cryptoCurrency.includes(ab.Symbol)
                      )}
                      islayout="dashboard"
                    />
                  );
                }}
              />
              <Route
                path={`/:lang/wallet/spread/currency`}
                render={() => {
                  return (
                    <AllSymbol
                      data={priceData?.filter((ab) => cfds.includes(ab.Symbol))}
                      islayout="dashboard"
                    />
                  );
                }}
              />
              <Route
                path={`/:lang/wallet/spread`}
                render={() => {
                  return <AllSymbol data={priceData} islayout="dashboard" />;
                }}
              />
            </Switch>
          )}
        </div>
      </div>
    </div>
  );
};

export default Symbols;
